import { Routes, Route, Link } from 'react-router-dom';
import DonationPage from './pages/DonationPage';
import SuccessPage from './pages/SuccessPage';
import FailurePage from './pages/FailurePage';
import CallbackPage from './pages/CallbackPage';

function App() {
  return (
    <div className="min-h-screen bg-dark flex flex-col">
      {/* Logo */}
      <div className="container mx-auto px-4 py-4">
        <Link to="/" className="text-2xl font-bold text-gold inline-block">
          haapu
        </Link>
      </div>

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<DonationPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/failure" element={<FailurePage />} />
          {/* Admin routes can be added later */}
        </Routes>
      </main>
    </div>
  );
}

export default App;
